import { Typography } from '@mui/joy';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import SubmitTicketForm from '~/features/tenant/ticket-submission/SubmitTicketForm';

export function Component() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCustomerPage = location.pathname.startsWith('/customer');

  return (
    <div className='bg-white min-h-full'>
      <div className='flex flex-col justify-center items-center rounded-none p-4 bg-gradient-to-b from-blue-700 to-brand-primary-500 '>
        <Typography className='!text-white !text-9xl font-bold'>
          <FormattedMessage defaultMessage='404'></FormattedMessage>
        </Typography>
        <Typography level='title-lg' className='!text-white font-normal'>
          <FormattedMessage defaultMessage='Oops'></FormattedMessage>
        </Typography>
        <Typography level='title-md' className='!text-white'>
          <FormattedMessage defaultMessage='Sorry this page could not be found, rest assured we are working to resolve this issue'></FormattedMessage>
        </Typography>
      </div>
      <div className='container max-w-3xl mx-auto p-8'>
        <div className='flex flex-col gap-4'>
          <Typography>
            <Link
              to={'..'}
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              <FormattedMessage defaultMessage='Return Home.' />
            </Link>
            &nbsp;
            {isCustomerPage ? (
              <FormattedMessage
                defaultMessage="If you need assistance or have any questions, just fill out the form
              - we're here to help!"
              />
            ) : (
              <FormattedMessage defaultMessage='Page not found.' />
            )}
          </Typography>
          {isCustomerPage && (
            <SubmitTicketForm
              defaultValues={{
                code: '404',
                errorPage: location.pathname,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
